import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { Injectable, InjectionToken, effect, inject } from '@angular/core';
import { getState, patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { cloneDeep } from 'lodash-es';
import { Image } from '../../model/image.model';

export type ImageEntity = {
    id: string;
    image: Image;
};

export type ImageState = {
    images: ImageEntity[];
};

const initialState: ImageState = {
    images: [],
};

const IMAGE_STATE = new InjectionToken<ImageState>('ImageState', {
    factory: () => initialState,
});

export const ImageStore = signalStore(
    { providedIn: 'root' },
    withState(() => inject(IMAGE_STATE)),
    withDevtools('campus-image'),
    withMethods(store => ({
        setImage(id: string, image: Image): void {
            const images = store.images().length > 0 ? store.images().filter(q => q.id != id) : [];
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            images.push({
                id,
                image: cloneDeep(image),
            });
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            patchState(store, _state => ({ images: [...images] }));
        },

        clear(): void {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            patchState(store, _state => ({ images: [] }));
        },

        get(id: string): Image {
            const result = store.images().length > 0 ? store.images().find(q => q.id == id) : undefined;
            if (result) {
                return cloneDeep(result).image;
            } else {
                return null;
            }
        },

        delete(id: string): void {
            const images = store.images().length > 0 ? store.images().filter(q => q.id != id) : [];
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            patchState(store, _state => ({ images }));
        },

        getAll(): ImageEntity[] {
            return store.images();
        },
    }))
);

@Injectable({ providedIn: 'root' })
export class ImageStoreService {
    store = inject(ImageStore);
    constructor() {
        effect(() => {
            const state = getState(this.store);
            console.log('ImageState changed', state);
        });
    }

    put(key: string, model: Image) {
        this.store.setImage(key, model);
    }

    delete(key: string) {
        this.store.delete(key);
    }

    get(id: string) {
        return this.store.get(id);
    }

    clear(): void {
        this.store.clear();
    }
}
